export default __webpack_public_path__ + "static/media/image-not-found.a0f012b4.svg";